import { render, staticRenderFns } from "./BirthdaysProgramDetails.vue?vue&type=template&id=224ab919&scoped=true&"
import script from "./BirthdaysProgramDetails.vue?vue&type=script&lang=ts&"
export * from "./BirthdaysProgramDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224ab919",
  null
  
)

export default component.exports